/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebInstytucjeNipRoboczeKrbIdDelete$Params {

/**
 * Identyfikator kopii.
 */
  krbId: number;
  nip: string;
}

export function apiWebInstytucjeNipRoboczeKrbIdDelete(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipRoboczeKrbIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipRoboczeKrbIdDelete.PATH, 'delete');
  if (params) {
    rb.path('krbId', params.krbId, {});
    rb.path('nip', params.nip, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiWebInstytucjeNipRoboczeKrbIdDelete.PATH = '/api/web/instytucje/{nip}/robocze/{krbId}';
